import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

//일진머티리얼즈 Router
const routes_mt = [
  {
    path: "/ijmt/visitRequest",
    name: "visitRequestMt",
    component: () => import("./views/mt/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijmt/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/mt/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijmt",
    name: "visitorMain",
    component: () => import("./views/mt/VisitorMain.vue"),
  },
  {
    name: "visitReserveMt",
    path: "/ijmt/visitReserve",
    component: () => import("./views/mt/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijmt/visitProposal",
    name: "visitProposal",
    component: () => import("./views/mt/VisitProposal.vue"),
  },
  {
    path: "/ijmt/visitStatus",
    name: "visitStatus",
    component: () => import("./views/mt/VisitStatus.vue"),
  },
  {
    path: "/ijmt/visitTerms",
    name: "visitTerms",
    component: () => import("./views/mt/VisitTerms.vue"),
  },
  {
    path: "/ijmt/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/mt/VisitPolicy.vue"),
  },
  {
    path: "/ijmt/board/notice",
    name: "noticeList",
    component: () => import("./views/mt/board/BoardList.vue"),
  },
  {
    path: "/ijmt/board/faq",
    name: "faqList",
    component: () => import("./views/mt/board/BoardList.vue"),
  },
  {
    path: "/ijmt/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/mt/board/BoardCreate.vue"),
  },
  {
    path: "/ijmt/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/mt/board/BoardDetail.vue"),
  },
  {
    path: "/ijmt/board/notice/modify",
    name: "noticeModifyMt",
    props: true,
    component: () => import("./views/mt/board/BoardCreate.vue"),
  },
  {
    path: "/ijmt/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/mt/board/BoardCreate.vue"),
  },
  {
    path: "/ijmt/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/mt/board/BoardDetail.vue"),
  },
  {
    path: "/ijmt/board/faq/modify",
    name: "faqModifyMt",
    props: true,
    component: () => import("./views/mt/board/BoardCreate.vue"),
  },
];

//일진복합소재 Router
const routes_bh = [
  {
    path: "/ijbh/visitRequest",
    name: "visitRequestBh",
    component: () => import("./views/bh/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijbh/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/bh/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijbh",
    name: "visitorMain",
    component: () => import("./views/bh/VisitorMain.vue"),
  },
  {
    name: "visitReserveBh",
    path: "/ijbh/visitReserve",
    component: () => import("./views/bh/VisitReserve.vue"),
    props: true,
  },
  {
    name: "visitProposal",
    path: "/ijbh/visitProposal",
    component: () => import("./views/bh/VisitProposal.vue"),
  },
  {
    path: "/ijbh/visitStatus",
    name: "visitStatus",
    component: () => import("./views/bh/VisitStatus.vue"),
  },
  {
    path: "/ijbh/visitTerms",
    name: "visitTerms",
    component: () => import("./views/bh/VisitTerms.vue"),
  },
  {
    path: "/ijbh/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/bh/VisitPolicy.vue"),
  },
  {
    path: "/ijbh/board/notice",
    name: "noticeList",
    component: () => import("./views/bh/board/BoardList.vue"),
  },
  {
    path: "/ijbh/board/faq",
    name: "faqList",
    component: () => import("./views/bh/board/BoardList.vue"),
  },
  {
    path: "/ijbh/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/bh/board/BoardCreate.vue"),
  },
  {
    path: "/ijbh/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/bh/board/BoardDetail.vue"),
  },
  {
    path: "/ijbh/board/notice/modify",
    name: "noticeModify",
    props: true,
    component: () => import("./views/bh/board/BoardCreate.vue"),
  },
  {
    path: "/ijbh/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/bh/board/BoardCreate.vue"),
  },
  {
    path: "/ijbh/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/bh/board/BoardDetail.vue"),
  },
  {
    path: "/ijbh/board/faq/modify",
    name: "faqModify",
    props: true,
    component: () => import("./views/bh/board/BoardCreate.vue"),
  },
];

//일진전기 Router
const routes_el = [
  {
    path: "/ijel/visitRequest",
    name: "visitRequestEl",
    component: () => import("./views/el/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijel/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/el/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijel",
    name: "visitorMain",
    component: () => import("./views/el/VisitorMain.vue"),
  },
  {
    name: "visitReserveEl",
    path: "/ijel/visitReserve",
    component: () => import("./views/el/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijel/visitProposal",
    name: "visitProposal",
    component: () => import("./views/el/VisitProposal.vue"),
  },
  {
    path: "/ijel/visitStatus",
    name: "visitStatus",
    component: () => import("./views/el/VisitStatus.vue"),
  },
  {
    path: "/ijel/visitTerms",
    name: "visitTerms",
    component: () => import("./views/el/VisitTerms.vue"),
  },
  {
    path: "/ijel/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/el/VisitPolicy.vue"),
  },
  {
    path: "/ijel/board/notice",
    name: "noticeList",
    component: () => import("./views/el/board/BoardList.vue"),
  },
  {
    path: "/ijel/board/faq",
    name: "faqList",
    component: () => import("./views/el/board/BoardList.vue"),
  },
  {
    path: "/ijel/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/el/board/BoardCreate.vue"),
  },
  {
    path: "/ijel/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/el/board/BoardDetail.vue"),
  },
  {
    path: "/ijel/board/notice/modify",
    name: "noticeModifyEl",
    props: true,
    component: () => import("./views/el/board/BoardCreate.vue"),
  },
  {
    path: "/ijel/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/el/board/BoardCreate.vue"),
  },
  {
    path: "/ijel/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/el/board/BoardDetail.vue"),
  },
  {
    path: "/ijel/board/faq/modify",
    name: "faqModifyEl",
    props: true,
    component: () => import("./views/el/board/BoardCreate.vue"),
  },
];

//일진C&S Router
const routes_cs = [
  {
    path: "/ijcs/visitRequest",
    name: "visitRequestCs",
    component: () => import("./views/cs/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijcs/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/cs/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijcs",
    name: "visitorMain",
    component: () => import("./views/cs/VisitorMain.vue"),
  },
  {
    name: "visitReserveCs",
    path: "/ijcs/visitReserve",
    component: () => import("./views/cs/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijcs/visitProposal",
    name: "visitProposal",
    component: () => import("./views/cs/VisitProposal.vue"),
  },
  {
    path: "/ijcs/visitStatus",
    name: "visitStatus",
    component: () => import("./views/cs/VisitStatus.vue"),
  },
  {
    path: "/ijcs/visitTerms",
    name: "visitTerms",
    component: () => import("./views/cs/VisitTerms.vue"),
  },
  {
    path: "/ijcs/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/cs/VisitPolicy.vue"),
  },
  {
    path: "/ijcs/board/notice",
    name: "noticeList",
    component: () => import("./views/cs/board/BoardList.vue"),
  },
  {
    path: "/ijcs/board/faq",
    name: "faqList",
    component: () => import("./views/cs/board/BoardList.vue"),
  },
  {
    path: "/ijcs/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/cs/board/BoardCreate.vue"),
  },
  {
    path: "/ijcs/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/cs/board/BoardDetail.vue"),
  },
  {
    path: "/ijcs/board/notice/modify",
    name: "noticeModify",
    props: true,
    component: () => import("./views/cs/board/BoardCreate.vue"),
  },
  {
    path: "/ijcs/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/cs/board/BoardCreate.vue"),
  },
  {
    path: "/ijcs/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/cs/board/BoardDetail.vue"),
  },
  {
    path: "/ijcs/board/faq/modify",
    name: "faqModify",
    props: true,
    component: () => import("./views/cs/board/BoardCreate.vue"),
  },
];

//다이아몬드
const routes_dm = [
  {
    path: "/ijdm/visitRequest",
    name: "visitRequestDm",
    component: () => import("./views/dm/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijdm/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/dm/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijdm",
    name: "visitorMain",
    component: () => import("./views/dm/VisitorMain.vue"),
  },
  {
    name: "visitReserveDm",
    path: "/ijdm/visitReserve",
    component: () => import("./views/dm/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijdm/visitProposal",
    name: "visitProposal",
    component: () => import("./views/dm/VisitProposal.vue"),
  },
  {
    path: "/ijdm/visitStatus",
    name: "visitStatus",
    component: () => import("./views/dm/VisitStatus.vue"),
  },
  {
    path: "/ijdm/visitTerms",
    name: "visitTerms",
    component: () => import("./views/dm/VisitTerms.vue"),
  },
  {
    path: "/ijdm/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/dm/VisitPolicy.vue"),
  },
  {
    path: "/ijdm/board/notice",
    name: "noticeList",
    component: () => import("./views/dm/board/BoardList.vue"),
  },
  {
    path: "/ijdm/board/faq",
    name: "faqList",
    component: () => import("./views/dm/board/BoardList.vue"),
  },
  {
    path: "/ijdm/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/dm/board/BoardCreate.vue"),
  },
  {
    path: "/ijdm/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/dm/board/BoardDetail.vue"),
  },
  {
    path: "/ijdm/board/notice/modify",
    name: "noticeModifyDm",
    props: true,
    component: () => import("./views/dm/board/BoardCreate.vue"),
  },
  {
    path: "/ijdm/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/dm/board/BoardCreate.vue"),
  },
  {
    path: "/ijdm/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/dm/board/BoardDetail.vue"),
  },
  {
    path: "/ijdm/board/faq/modify",
    name: "faqModifyDm",
    props: true,
    component: () => import("./views/dm/board/BoardCreate.vue"),
  },
];

//제강
const routes_st = [
  {
    path: "/ijst/visitRequest",
    name: "visitRequestSt",
    component: () => import("./views/st/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijst/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/st/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijst",
    name: "visitorMain",
    component: () => import("./views/st/VisitorMain.vue"),
  },
  {
    name: "visitReserveSt",
    path: "/ijst/visitReserve",
    component: () => import("./views/st/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijst/visitProposal",
    name: "visitProposal",
    component: () => import("./views/st/VisitProposal.vue"),
  },
  {
    path: "/ijst/visitStatus",
    name: "visitStatus",
    component: () => import("./views/st/VisitStatus.vue"),
  },
  {
    path: "/ijst/visitTerms",
    name: "visitTerms",
    component: () => import("./views/st/VisitTerms.vue"),
  },
  {
    path: "/ijst/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/st/VisitPolicy.vue"),
  },
  {
    path: "/ijst/board/notice",
    name: "noticeList",
    component: () => import("./views/st/board/BoardList.vue"),
  },
  {
    path: "/ijst/board/faq",
    name: "faqList",
    component: () => import("./views/st/board/BoardList.vue"),
  },
  {
    path: "/ijst/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/st/board/BoardCreate.vue"),
  },
  {
    path: "/ijst/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/st/board/BoardDetail.vue"),
  },
  {
    path: "/ijst/board/notice/modify",
    name: "noticeModifySt",
    props: true,
    component: () => import("./views/st/board/BoardCreate.vue"),
  },
  {
    path: "/ijst/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/st/board/BoardCreate.vue"),
  },
  {
    path: "/ijst/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/st/board/BoardDetail.vue"),
  },
  {
    path: "/ijst/board/faq/modify",
    name: "faqModifySt",
    props: true,
    component: () => import("./views/st/board/BoardCreate.vue"),
  },
];

//홀딩스
const routes_hd = [
  {
    path: "/ijhd/visitRequest",
    name: "visitRequestHd",
    component: () => import("./views/hd/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijhd/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/hd/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijhd",
    name: "visitorMain",
    component: () => import("./views/hd/VisitorMain.vue"),
  },
  {
    name: "visitReserveHd",
    path: "/ijhd/visitReserve",
    component: () => import("./views/hd/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijhd/visitProposal",
    name: "visitProposal",
    component: () => import("./views/hd/VisitProposal.vue"),
  },
  {
    path: "/ijhd/visitStatus",
    name: "visitStatus",
    component: () => import("./views/hd/VisitStatus.vue"),
  },
  {
    path: "/ijhd/visitTerms",
    name: "visitTerms",
    component: () => import("./views/hd/VisitTerms.vue"),
  },
  {
    path: "/ijhd/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/hd/VisitPolicy.vue"),
  },
  {
    path: "/ijhd/board/notice",
    name: "noticeList",
    component: () => import("./views/hd/board/BoardList.vue"),
  },
  {
    path: "/ijhd/board/faq",
    name: "faqList",
    component: () => import("./views/hd/board/BoardList.vue"),
  },
  {
    path: "/ijhd/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/hd/board/BoardCreate.vue"),
  },
  {
    path: "/ijhd/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/hd/board/BoardDetail.vue"),
  },
  {
    path: "/ijhd/board/notice/modify",
    name: "noticeModifyHd",
    props: true,
    component: () => import("./views/hd/board/BoardCreate.vue"),
  },
  {
    path: "/ijhd/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/hd/board/BoardCreate.vue"),
  },
  {
    path: "/ijhd/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/hd/board/BoardDetail.vue"),
  },
  {
    path: "/ijhd/board/faq/modify",
    name: "faqModifyHd",
    props: true,
    component: () => import("./views/hd/board/BoardCreate.vue"),
  },
];

//알피니언
const routes_ap = [
  {
    path: "/ijap/visitRequest",
    name: "visitRequestAp",
    component: () => import("./views/ap/visitorbook/VisitRequest.vue"),
    props: true,
  },
  {
    path: "/ijap/visitRequestProposal",
    name: "visitRequestProposal",
    component: () => import("./views/ap/visitorbook/VisitRequestProposal.vue"),
  },
  {
    path: "/ijap",
    name: "visitorMain",
    component: () => import("./views/ap/VisitorMain.vue"),
  },
  {
    name: "visitReserveAp",
    path: "/ijap/visitReserve",
    component: () => import("./views/ap/VisitReserve.vue"),
    props: true,
  },
  {
    path: "/ijap/visitProposal",
    name: "visitProposal",
    component: () => import("./views/ap/VisitProposal.vue"),
  },
  {
    path: "/ijap/visitStatus",
    name: "visitStatus",
    component: () => import("./views/ap/VisitStatus.vue"),
  },
  {
    path: "/ijap/visitTerms",
    name: "visitTerms",
    component: () => import("./views/ap/VisitTerms.vue"),
  },
  {
    path: "/ijap/visitPolicy",
    name: "visitPolicy",
    component: () => import("./views/ap/VisitPolicy.vue"),
  },
  {
    path: "/ijap/board/notice",
    name: "noticeList",
    component: () => import("./views/ap/board/BoardList.vue"),
  },
  {
    path: "/ijap/board/faq",
    name: "faqList",
    component: () => import("./views/ap/board/BoardList.vue"),
  },
  {
    path: "/ijap/board/notice/create",
    name: "noticeCreate",
    props: true,
    component: () => import("./views/ap/board/BoardCreate.vue"),
  },
  {
    path: "/ijap/board/notice/detail/:contentId",
    name: "noticeDetail",
    props: true,
    component: () => import("./views/ap/board/BoardDetail.vue"),
  },
  {
    path: "/ijap/board/notice/modify",
    name: "noticeModifyAp",
    props: true,
    component: () => import("./views/ap/board/BoardCreate.vue"),
  },
  {
    path: "/ijap/board/faq/create",
    name: "faqCreate",
    props: true,
    component: () => import("./views/ap/board/BoardCreate.vue"),
  },
  {
    path: "/ijap/board/faq/detail/:contentId",
    name: "faqDetail",
    props: true,
    component: () => import("./views/ap/board/BoardDetail.vue"),
  },
  {
    path: "/ijap/board/faq/modify",
    name: "faqModifyAp",
    props: true,
    component: () => import("./views/ap/board/BoardCreate.vue"),
  },
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/loginM",
      name: "LoginManual",
      props: true,
      component: () => import("./components/LoginManual.vue"),
    },
    // {
    //   path: "/",
    //   name: "groupMain",
    //   component: () => import("./views/GroupMain.vue"),
    // },
    {
      path: "/",
      redirect: "/ijst"
    },
    {
      path: "/login",
      name: "Login",
      props: true,
      component: () => import("./components/Login.vue"),
    },
    {
      path: "/visitNotice",
      name: "visitNotice",
      component: () => import("./views/VisitNotice.vue"),
    },
    {
      path: "/visitFaq",
      name: "visitFaq",
      component: () => import("./views/VisitFaq.vue"),
    },
    {
      path: "/backOffice",
      name: "main",
      component: () => import("./views/MyMain.vue"),
    },
    {
      path: "/backOffice/quickSetting",
      name: "quickSetting",
      component: () => import("./views/QuickSetting.vue"),
    },
    {
      path: "/backOffice/apprPendLst",
      name: "apprPendLst",
      component: () => import("./views/ApprPendLst.vue"),
    },
    {
      path: "/backOffice/apprDtlQry/:docMngNo",
      name: "apprDtlQry",
      props: true,
      component: () => import("./views/ApprDtlQry.vue"),
    },
    {
      path: "/backOffice/apprCompLst",
      name: "apprCompLst",
      component: () => import("./views/ApprCompLst.vue"),
    },
    {
      path: "/backOffice/apprReqLst",
      name: "apprReqLst",
      component: () => import("./views/ApprReqLst.vue"),
    },
    {
      path: "/backOffice/apprDropLst",
      name: "apprDropLst",
      component: () => import("./views/ApprDropLst.vue"),
    },
    {
      path: "/backOffice/apprReferLst",
      name: "apprReferLst",
      component: () => import("./views/ApprReferLst.vue"),
    },
    {
      path: "/backOffice/apprMndSet",
      name: "apprMndSet",
      component: () => import("./views/ApprMndSet.vue"),
    },
    {
      path: "/backOffice/apprRuleSet",
      name: "apprRuleSet",
      component: () => import("./views/ApprRuleSet.vue"),
    },
    {
      path: "/backOffice/authMng",
      name: "authMng",
      component: () => import("./views/AuthMng.vue"),
    },
    {
      path: "/backOffice/pgmMng",
      name: "pgmMng",
      component: () => import("./views/PgmMng.vue"),
    },
    {
      path: "/backOffice/funcMng",
      name: "funcMng",
      component: () => import("./views/FuncMng.vue"),
    },
    {
      path: "/backOffice/termsListMng",
      name: "termsListMng",
      component: () => import("./views/TermsListMng.vue"),
    },
    {
      path: "/backOffice/terms/create",
      name: "termsCreate",
      props: true,
      component: () => import("./views/TermsCreate.vue"),
    },
    {
      path: "/backOffice/terms/detail/:contentId",
      name: "termsDetail",
      props: true,
      component: () => import("./views/TermsDetail.vue"),
    },
    {
      path: "/backOffice/codeMng",
      name: "codeMng",
      component: () => import("./views/CodeMng.vue"),
    },
    {
      path: "/backOffice/visitList",
      name: "visitList",
      component: () => import("./views/VisitList.vue"),
    },
    {
      path: "/backOffice/visitMgList",
      name: "visitMgList",
      component: () => import("./views/VisitMgList.vue"),
    },
    {
      path: "/backOffice/visitMng/:visitNo",
      name: "visitMng",
      props: true,
      component: () => import("./views/VisitMng.vue"),
    },
    {
      path: "/backOffice/visitMngMg/:visitNo",
      name: "visitMngMg",
      props: true,
      component: () => import("./views/VisitMngMg.vue"),
    },
    {
      path: "/backOffice/visitMngList",
      name: "visitMngList",
      component: () => import("./views/VisitMngList.vue"),
    },
    {
      path: "/backOffice/visitMngMgList",
      name: "visitMngMgList",
      component: () => import("./views/VisitMngMgList.vue"),
    },
    {
      path: "/backOffice/visitControlMng/:visitNo",
      name: "visitControlMng",
      props: true,
      component: () => import("./views/VisitControlMng.vue"),
    },
    {
      path: "/backOffice/visitControlMgMng/:visitNo",
      name: "visitControlMgMng",
      props: true,
      component: () => import("./views/VisitControlMgMng.vue"),
    },
    {
      path: "/backOffice/visitorIngList",
      name: "visitorIngList",
      component: () => import("./views/VisitorIngList.vue"),
    },
    {
      path: "/backOffice/visitorIngMgList",
      name: "visitorIngMgList",
      component: () => import("./views/VisitorIngMgList.vue"),
    },
    {
      path: "/backOffice/visitStatisticsPeriod",
      name: "VisitStatisticsPeriod",
      props: true,
      component: () => import("./views/VisitStatisticsPeriod.vue"),
    },
    {
      path: "/backOffice/visitStatisticsPeriodMg",
      name: "VisitStatisticsPeriodMg",
      props: true,
      component: () => import("./views/VisitStatisticsPeriodMg.vue"),
    },
    {
      path: "/backOffice/visitStatisticsDept",
      name: "VisitStatisticsDept",
      props: true,
      component: () => import("./views/VisitStatisticsDept.vue"),
    },
    {
      path: "/backOffice/visitStatisticsDeptMg",
      name: "VisitStatisticsDeptMg",
      props: true,
      component: () => import("./views/VisitStatisticsDeptMg.vue"),
    },
    {
      path: "/backOffice/visitStatisticsCategory",
      name: "VisitStatisticsCategory",
      props: true,
      component: () => import("./views/VisitStatisticsCategory.vue"),
    },
    {
      path: "/backOffice/visitStatisticsCategoryMg",
      name: "VisitStatisticsCategoryMg",
      props: true,
      component: () => import("./views/VisitStatisticsCategoryMg.vue"),
    },
    {
      path: "/backOffice/visitSecuItemList",
      name: "visitSecuItemList",
      component: () => import("./views/VisitSecuItemList.vue"),
    },
    {
      path: "/backOffice/visitCarList",
      name: "visitCarList",
      component: () => import("./views/VisitCarList.vue"),
    },
    {
      path: "/backOffice/blackList",
      name: "blackList",
      component: () => import("./views/BlackList.vue"),
    },
    {
      path: "/backOffice/blackListMg",
      name: "blackListMg",
      component: () => import("./views/BlackListMg.vue"),
    },
    {
      path: "/backOffice/VehicleList",
      name: "VehicleList",
      component: () => import("./views/VehicleList.vue"),
    },
    {
      path: "/backOffice/visitSecuItemMgList",
      name: "visitSecuItemMgList",
      component: () => import("./views/VisitSecuItemMgList.vue"),
    },
    {
      path: "/ijmg/visitRequest",
      name: "visitRequestMg",
      component: () => import("./views/mg/visitorbook/VisitRequest.vue"),
      props: true,
    },
    {
      path: "/ijmg/visitRequestProposal",
      name: "visitRequestProposal",
      component: () =>
        import("./views/mg/visitorbook/VisitRequestProposal.vue"),
    },
  ]
    .concat(routes_mt)
    .concat(routes_bh)
    .concat(routes_el)
    .concat(routes_cs)
    .concat(routes_dm)
    .concat(routes_st)
    .concat(routes_hd)
    .concat(routes_ap),
});
